<template>

    <div>

        <!-- Table Container Card -->
        <b-card
            no-body
            class="mb-0">

            <div class="m-2">

                <!-- Table Top -->
                <b-row>

                    <!-- Per Page -->
                    <b-col
                        cols="12"
                        md="4"
                        class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
                        <label>Mostrar</label>
                        <v-select
                            v-model="perPage"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            :options="perPageOptions"
                            :clearable="false"
                            class="per-page-selector d-inline-block mx-50"
                        />
                        <label>registros</label>
                    </b-col>

                    <!-- Search -->
                    <b-col
                        cols="12"
                        md="6"
                        class="ml-auto">
                        <div class="d-flex">
                            <b-form-input
                                v-model="searchQuery"
                                class="d-inline-block mr-1"
                                placeholder="Buscar blog ..."
                                trim
                            />
                            <b-button
                                variant="primary"
                                :to="{ name: 'blogs-create' }"
                                class="text-nowrap"
                            >
                                Agregar
                            </b-button>
                        </div>
                    </b-col>
                </b-row>

            </div>

            <b-table
                ref="refBlogListTable"
                class="position-relative"
                :style="totalBlogs < 3 && totalBlogs > 0 ? 'height: 250px' : 'height: inherit'"
                :items="fetchBlogs"
                responsive
                :fields="tableColumns"
                primary-key="id"
                :sort-by.sync="sortBy"
                show-empty
                empty-text="No se encontraron registros coincidentes"
                :sort-desc.sync="isSortDirDesc">

                <template #cell(title)="data">
                    <b-media vertical-align="center">
                        <template #aside>
                            <b-img
                                v-if="data.item.image"
                                :src="data.item.image"
                                width="60"
                                height="40"
                                rounded
                                style="object-fit: cover;"
                                alt="portada"
                            />
                        </template>
                        <b-link
                            :to="{ name: 'blogs-edit', params: { id: data.item.id } }"
                            class="font-weight-bold d-block">
                            {{ data.item.title }}
                        </b-link>
                        <small class="text-muted">{{ data.item.short_description | truncate }}</small>
                    </b-media>
                </template>

                <template #cell(doctor_fullname)="data">
                    <span v-if="data.item.doctor_fullname">{{ data.item.doctor_fullname }}</span>
                    <span v-else class="text-muted">-</span>
                </template>

                <template #cell(tags)="data">
                    <div v-if="data.item.tags && data.item.tags.length">
                        <b-badge
                            v-for="(tag, index) in data.item.tags"
                            :key="index"
                            pill
                            variant="light-primary"
                            class="mr-25 mb-25"
                        >
                            {{ tag }}
                        </b-badge>
                    </div>
                    <span v-else class="text-muted">-</span>
                </template>

                <template #cell(blog_state_name)="data">
                    <b-badge
                        pill
                        :variant="data.item.blog_state_color"
                    >
                        {{ data.item.blog_state_name }}
                    </b-badge>
                </template>

                <template #cell(published_at)="data">
                    <span v-if="data.item.published_at">{{ moment(data.item.published_at).format('DD/MM/YYYY HH:mm') }}</span>
                    <span v-else class="text-muted">-</span>
                </template>

                <template #cell(actions)="data">
                    <b-dropdown
                        variant="link"
                        no-caret
                        :right="$store.state.appConfig.isRTL">

                        <template #button-content>
                            <feather-icon
                                icon="MoreVerticalIcon"
                                size="16"
                                class="align-middle text-body"
                            />
                        </template>

                        <b-dropdown-item :to="{ name: 'blogs-edit', params: { id: data.item.id } }">
                            <feather-icon icon="EditIcon" />
                            <span class="align-middle ml-50">Editar</span>
                        </b-dropdown-item>

                        <b-dropdown-item
                            v-if="data.item.blog_state_id !== 2"
                            @click="publishBlog(data.item.id)"
                        >
                            <feather-icon icon="UploadCloudIcon" />
                            <span class="align-middle ml-50">Publicar</span>
                        </b-dropdown-item>

                        <b-dropdown-item
                            v-if="data.item.blog_state_id === 2"
                            @click="hideBlog(data.item.id)"
                        >
                            <feather-icon icon="EyeOffIcon" />
                            <span class="align-middle ml-50">Ocultar</span>
                        </b-dropdown-item>

                        <b-dropdown-item @click="deleteBlog(data.item.id)">
                            <feather-icon icon="TrashIcon" />
                            <span class="align-middle ml-50">Eliminar</span>
                        </b-dropdown-item>
                    </b-dropdown>
                </template>

            </b-table>
            <div class="mx-2 mb-2">
                <b-row>

                    <b-col
                        cols="12"
                        sm="6"
                        class="d-flex align-items-center justify-content-center justify-content-sm-start">
                        <span class="text-muted">Mostrando {{ dataMeta.from }} al {{ dataMeta.to }} de {{ dataMeta.of }} registros</span>
                    </b-col>

                    <b-col
                        cols="12"
                        sm="6"
                        class="d-flex align-items-center justify-content-center justify-content-sm-end">

                        <b-pagination
                            v-model="currentPage"
                            :total-rows="totalBlogs"
                            :per-page="perPage"
                            first-number
                            last-number
                            class="mb-0 mt-1 mt-sm-0"
                            prev-class="prev-item"
                            next-class="next-item">

                            <template #prev-text>
                                <feather-icon
                                    icon="ChevronLeftIcon"
                                    size="18"
                                />
                            </template>
                            <template #next-text>
                                <feather-icon
                                    icon="ChevronRightIcon"
                                    size="18"
                                />
                            </template>
                        </b-pagination>

                    </b-col>

                </b-row>
            </div>
        </b-card>
    </div>
</template>

<script>

    import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
    import { useToast } from 'vue-toastification/composition';
    import { onUnmounted } from '@vue/composition-api';
    import blogStoreModule from '../blogStoreModule';
    import VueSweetalert2 from 'vue-sweetalert2';
    import useBlogsList from './useBlogsList';
    import vSelect from 'vue-select';
    import store from '@/store';
    import moment from 'moment';
    import Vue from 'vue';
    import 'animate.css';

    Vue.use(VueSweetalert2);

    export default {
        components: {
            vSelect
        },
        filters: {
            truncate(value) {
                if (!value) return '';
                return value.length > 80 ? `${value.substring(0, 80)}...` : value;
            }
        },
        data() {
            return {
                moment
            }
        },
        setup() {

            // USE TOAST
            const toast = useToast();

            const BLOG_APP_STORE_MODULE_NAME = 'app-blog';

            // REGISTER MODULE
            if (!store.hasModule(BLOG_APP_STORE_MODULE_NAME)) store.registerModule(BLOG_APP_STORE_MODULE_NAME, blogStoreModule);

            // UNREGISTER ON LEAVE
            onUnmounted(() => {
                if (store.hasModule(BLOG_APP_STORE_MODULE_NAME)) store.unregisterModule(BLOG_APP_STORE_MODULE_NAME);
            });

            const {
                fetchBlogs,
                tableColumns,
                perPage,
                currentPage,
                totalBlogs,
                dataMeta,
                perPageOptions,
                searchQuery,
                sortBy,
                isSortDirDesc,
                refBlogListTable,

                refetchData
            } = useBlogsList();

            const showToast = (title, icon, variant) => {
                toast({
                    component: ToastificationContent,
                    props: { title, icon, variant }
                });
            };

            const publishBlog = (id) => {
                store.dispatch('app-blog/publishBlog', { id })
                    .then(response => {
                        refetchData();
                        showToast(response.data.message, 'CheckIcon', 'success');
                    })
                    .catch(() => showToast('Error al publicar el blog.', 'AlertTriangleIcon', 'danger'));
            };

            const hideBlog = (id) => {
                store.dispatch('app-blog/hideBlog', { id })
                    .then(response => {
                        refetchData();
                        showToast(response.data.message, 'CheckIcon', 'success');
                    })
                    .catch(() => showToast('Error al ocultar el blog.', 'AlertTriangleIcon', 'danger'));
            };

            const deleteBlog = (id) => {
                Vue.swal({
                    title: '¿Estás seguro de eliminar el blog?',
                    text: "¡Si no lo está, puede cancelar la acción!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Sí, eliminar!',
                    cancelButtonText: 'Cancelar',
                    customClass: {
                        confirmButton: 'btn btn-primary',
                        cancelButton: 'btn btn-outline-danger ml-1'
                    },
                    showClass: {
                        popup: 'animate__animated animate__tada'
                    },
                    buttonsStyling: false
                }).then(result => {
                    if (result.value) {
                        store.dispatch('app-blog/deleteBlog', { id })
                            .then(response => {
                                refetchData();
                                showToast(response.data.message, 'CheckIcon', 'success');
                            })
                            .catch(() => showToast('Error al eliminar el blog.', 'AlertTriangleIcon', 'danger'));
                    }
                });
            };

            return {
                fetchBlogs,
                tableColumns,
                perPage,
                currentPage,
                totalBlogs,
                dataMeta,
                perPageOptions,
                searchQuery,
                sortBy,
                isSortDirDesc,
                refBlogListTable,

                refetchData,

                publishBlog,
                hideBlog,
                deleteBlog
            }
        }
    }

</script>

<style lang="scss" scoped>

    .media {
        align-items: center;
    }

    .per-page-selector {
        width: 90px;
    }

</style>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-select.scss';
    @import '@core/scss/vue/libs/vue-sweetalert.scss';
</style>
